import { CustomProductCardEnt } from "./custom-product-card-ent";

export class IItemWishList {
    productStatus?: string;
    productStatusName?: string;
    idProduct?: string;
    product: CustomProductCardEnt = new CustomProductCardEnt();
    cant: number = 0;
    size?: string;
}
